import { Typography, styled } from '@mui/material';

const StyledSingleCounterTitle = styled(Typography)(({ theme }) => ({
  // 12px en xs: con las tres tarjetas en una fila cada una mide ~95px de contenido y a 14px
  // "Último pago" partía la palabra por la mitad.
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 600,
  lineHeight: 1.25,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(18)
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.pxToRem(20)
  }
}));

export default StyledSingleCounterTitle;
